// extracted by mini-css-extract-plugin
export default {"title":"KeyValueInput_title__tFaRh","inputRow":"KeyValueInput_inputRow__SoEZn","inputRowText":"KeyValueInput_inputRowText__Bb2Jq","inputField":"KeyValueInput_inputField__6gO8H"};